import { Component, OnInit, Inject } from '@angular/core';
import 'style-loader!./common.component.scss';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'dialog-anonimo',
    templateUrl: './anonimo.component.html',
})
export class ANONIMOComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IANONIMO,
        public dialogRef: MatDialogRef<ANONIMOComponent>,

    ) {
    }

    ngOnInit() {
       // console.log("init anonimo "+this.data.action)
    }


    CloseMe(value) {
        this.dialogRef.close(value)
    }
}


export interface IANONIMO {
    title;
    content;
    codTessera;
    username;
    action: any[];
}


// WEBPACK FOOTER //
// ./src/app/theme/shared/dialogs/anonimo.component.ts